/**
 * Amazon Connect reports state names in PascalCase — "AfterCallWork",
 * "CallingCustomer", "FailedConnectCustomer" — and custom states exactly as an
 * admin typed them ("Lunch break"). The footer and the failure notice show
 * these verbatim otherwise, so word boundaries are restored for display:
 * a space before each lower→upper transition (and between an acronym and the
 * word after it), then the first letter capitalised for names that arrive in
 * camelCase. Names that already contain spaces pass through unchanged.
 */
export const formatAgentStateName = (name: string): string =>
  name
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/^[a-z]/, (first) => first.toUpperCase());
